<template>

    <div style="width: 611px;">
        <!-- 表格 -->
        <div class="tabel-box" style="margin-top: 4px;">
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one"></div>
                <div class="tabel-tr-title-item mr">偏低</div>
                <div class="tabel-tr-title-item mr">标准</div>
                <div class="tabel-tr-title-item mr">偏高</div>
                <div class="tabel-tr-title-item mr">标准范围</div>
                <div class="tabel-tr-title-item mr">与上次对比</div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one">&nbsp;&nbsp;内脏脂肪等级</div>
                <div class="tabel-tr-title-item-prograss">
                    <ProgressBar :standardValue="isBodyDataNotEmpty() ? bodyData.visceralFatGrade[0].value : ''"
                        :progressValue="isBodyDataNotEmpty() ? weightStandardCalculate(bodyData.visceralFatGrade[0]) : ''"
                        :width="294" :height="7" />
                </div>

                <div class="tabel-tr-title-item-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.visceralFatGrade[0].scope : ''
                    }}]
                </div>
                <div class="tabel-tr-title-item-contrast">
                    <img class="tabel-tr-title-item-contrast-img"
                        :src="isBodyDataNotEmpty() ? swichUpOrDown(bodyData.visceralFatGrade[0].value, lstBody[7].value) : ''" />
                    {{ isBodyDataNotEmpty() ? Math.abs(bodyData.visceralFatGrade[0].value - lstBody[7].value).toFixed(1) : '' }}
                </div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>

        </div>

    </div>
</template>
<script>
import ProgressBar from '@/components/ProgressBar.vue';
export default {
    props: {
        bodyData: {
            type: Object,
            required: true
        },
        lstBody: {
            type: Array,
            required: true
        }
    },

    data() {
        return {

        }
    },
    components: {

        ProgressBar,

    },
    methods: {
        //计算比例
        weightStandardCalculate(composition) {
            const lval = Number(composition.lval)
            const rval = Number(composition.rval)
            const value = Number(composition.value)
            // 最小值
            let minNumber = lval - (rval - lval);
            // 最大值
            let maxNumber = rval + (rval - lval);
            // 获取值的百分比
            let averageNumber = (value - minNumber) * 100 / (maxNumber - minNumber);
            if (averageNumber > 100) {
                averageNumber = 100;
            } else if (averageNumber < 10) {
                averageNumber = 10;
            }
            return Math.round(averageNumber);
        },
        //swich上下剪头图片
        swichUpOrDown(thisNumber, lastNumber) {
            //下降
            if ((Number(thisNumber) - Number(lastNumber)) < 0) {
                return require("@/assets/icon-contrast-up.png")
            } else if ((Number(thisNumber) - Number(lastNumber)) == 0) {
            } else {
                return require("@/assets/icon-contrast-down.png")
            }
        },
        isBodyDataNotEmpty() {
            return this.bodyData && Object.keys(this.bodyData).length > 0;
        }
    }
}
</script>

<style scoped>
/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: column;
    border: 1px solid #F0F9F6;
}

.tabel-tr-flex {
    display: flex;
    flex-direction: row;
}

/* 白色下划线 */
.line-white {
    height: 1px;
    background: #F0F9F6;
    width: 112px;
}

/* 绿色下划线 */
.line-green {
    background: #F0F9F6;
    height: 1px;
    width: 494px;
}

.tabel-tr-title-one {
    width: 112px;
    height: 34px;
    line-height: 34px;
    text-align: left;
    font-weight: bold;
    font-size: 13px;
    color: #333333;
}

.tabel-tr-title-item {
    width: 96px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-nomal {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-nomal {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
}

.tabel-tr-title-item-prograss {
    width: 294px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;

}

.tabel-tr-title-item-contrast {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: bold;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-contrast-img {
    width: 5px;
    height: 9px;
}

.mr {
    margin-left: 1px;
}

.unit-span {
    font-weight: 500;
    font-size: 11px;
    color: #333333;
    line-height: 16px;
}
</style>